<template>
  <div class="row">
    <div :class="accion_ruta ? 'col-md-12' : 'col-md-7'">
      <div class="card m-0">
        <div class="card-header p-1 bg-light">
          <div class="row">
            <div class="col-md-2">
              <label
                class="badge text-md mr-2 mb-0 align-top"
                :class="accion_ruta ? 'bg-geogo text-white' : 'bg-secondary'"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="accion_ruta"
                    type="checkbox"
                    id="accion_ruta"
                    class="custom-control-input"
                    checked=""
                    @click="viewMap.nodos = false"
                  />
                  <label for="accion_ruta" class="custom-control-label">
                    <i class="fas fa-edit text-xl p-1"></i>
                  </label>
                </div>
                <div class="text-center">
                  <span
                    class="badge"
                    :class="accion_ruta ? 'bg-success text-white' : 'bg-dark'"
                  >
                    Editar Tramo de Ruta
                  </span>
                </div>
              </label>
            </div>
            <div class="col-md-2" v-if="accion_ruta">
              <label
                class="badge text-md mr-2 mb-0 align-top"
                :class="accion_coordenadas ? 'bg-coordenadas' : 'bg-secondary'"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="accion_coordenadas"
                    @change="resetCoors"
                    type="checkbox"
                    id="accion_coordenadas"
                    class="custom-control-input"
                    checked=""
                  />
                  <label for="accion_coordenadas" class="custom-control-label">
                    <i class="fas fa-compass text-xl p-1"></i>
                  </label>
                </div>
                <div class="text-center">
                  <span
                    class="badge"
                    :class="
                      accion_coordenadas ? 'bg-success text-white' : 'bg-dark'
                    "
                  >
                    Coordenadas
                  </span>
                </div>
              </label>
            </div>
            <div class="col-md-3" v-if="accion_ruta">
              <label class="mb-0">Buscar Origen:</label>
              <gmap-autocomplete
                v-if="!accion_coordenadas"
                class="form-control form-control-sm"
                @place_changed="setPlaceOrigen"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
                :value="addressInput"
              >
                >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Location Of Event"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
              <div v-else>
                <input
                  v-model="coords.lat_origen"
                  @blur="setCoordOrigen"
                  type="text"
                  placeholder="Latitud"
                  class="form-control form-control-sm col-12 mb-1"
                />
                <input
                  v-model="coords.lng_origen"
                  @blur="setCoordOrigen"
                  type="text"
                  placeholder="Longitud"
                  class="form-control form-control-sm col-12 mb-1"
                />
              </div>
            </div>

            <div
              class="col-md-3"
              v-if="accion_ruta && markers.tramo_ruta.path.length > 0"
            >
              <label class="mb-0">Buscar Destino:</label>
              <gmap-autocomplete
                v-if="!accion_coordenadas"
                class="form-control form-control-sm"
                @place_changed="setPlaceDestino"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
                :value="addressInput"
              >
                >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Location Of Event"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
              <div v-else>
                <input
                  v-model="coords.lat_destino"
                  @blur="setCoordDestino"
                  type="text"
                  placeholder="Latitud"
                  class="form-control form-control-sm col-12 mb-1"
                />
                <input
                  v-model="coords.lng_destino"
                  @blur="setCoordDestino"
                  type="text"
                  placeholder="Longitud"
                  class="form-control form-control-sm col-12 mb-1"
                />
              </div>
            </div>
            <div
              class="col-md-2"
              v-if="accion_ruta && markers.tramo_ruta.path.length > 1"
            >
              <label class="badge text-md mr-2 mb-0 align-top bg-success">
                <button
                  @click="save()"
                  type="button"
                  class="btn btn-sm btn-success"
                >
                  <i class="fas fa-paper-plane text-lg p-1"></i><br />Guardar
                </button>
              </label>
            </div>
          </div>
        </div>
        <!-- Direcciones Google y Códigos Dane -->
        <!-- <div
          v-if="accion_ruta && markers.tramo_ruta.path.length > 1"
          class="card-body"
        >
          <div class="row">
            <div class="form-group col-md-2 text-center">
              <label for="">Nodos DANE</label>
              <input
                type="checkbox"
                class="form-control form-control-sm"
                v-model="chkCodDane"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" v-if="!chkCodDane">
              <label>Direcciones Google:</label>
              <gmap-autocomplete
                class="form-control form-control-sm"
                @place_changed="setPlaceWaypoint"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
                :value="addressInput"
              >
                >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Location Of Event"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
              <hr />
              <div v-if="markers.waypoints.length > 0" class="table-responsive">
                <table class="table table-bordered text-nowraptable-sm">
                  <thead class="bg-dark text-white">
                    <tr>
                      <th>Referencia</th>
                      <th class="col-3">Latitud</th>
                      <th class="col-3">Longitud</th>
                      <th class="col-1">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(wp, index) in markers.waypoints" :key="index">
                      <td>
                        <small>Referencia {{ index + 1 }}</small>
                      </td>
                      <td>
                        <small>{{ wp.location.lat }}</small>
                      </td>
                      <td>
                        <small>{{ wp.location.lng }}</small>
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-xs bg-danger"
                            @click="removeWaypoint(index)"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-12" v-if="chkCodDane">
              <label>Codigos Dane:</label>
              <v-select
                v-model="codDane"
                placeholder="Codigo"
                label="codigo"
                class="form-control form-control-sm p-0"
                :options="ListasForm.codigosDane"
                @search="buscarCodigosDane"
                @input="setCodDaneWaypoint"
              ></v-select>

              <hr />

              <div v-if="detCodDane.length > 0" class="table-responsive">
                <table class="table table-bordered text-nowrap table-sm">
                  <thead class="bg-dark text-white">
                    <tr>
                      <th>Referencia</th>
                      <th class="col-3">Latitud</th>
                      <th class="col-3">Longitud</th>
                      <th class="col-1">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(wp, index) in detCodDane" :key="index">
                      <td>
                        <small>{{ wp.codigo }}</small>
                      </td>
                      <td>
                        <small>{{ wp.latitud }}</small>
                      </td>
                      <td>
                        <small>{{ wp.longitud }}</small>
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-xs bg-danger"
                            @click="removeCodDaneWaypoint(index)"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button @click="actDatos()" class="btn btn-primary">
                  Calcular
                </button>
              </div>
            </div>
          </div>
        </div> -->
        <!-- Visualización Mapa -->
        <div class="card-body p-0">
          <gmap-map
            class="w-100"
            style="height: 500px"
            id="mapNodos"
            :center="viewMap.center"
            :zoom="viewMap.zoom"
            :options="{
              disableDefaultUI: true,
              zoomControl: true,
              mapTypeControl: true,
            }"
          >
            <!-- Iconos de los nodos -->
            <div v-if="viewMap.nodos">
              <gmap-marker
                :key="sitio.id"
                v-for="sitio in markers.nodos"
                :position="sitio.position"
                :icon="url_docs + '/' + sitio.icon"
                :clickable="true"
                @click="
                  (viewMap.center = sitio.position), toggleInfoWindow(sitio)
                "
              ></gmap-marker>
            </div>
            <!-- Popup de informaciones -->
            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div v-html="infoContent"></div>
            </gmap-info-window>
            <!-- Polilíneas Ruta -->
            <div v-if="tramoRuta">
              <!-- Recorrido ruta -->
              <gmap-polyline
                v-if="markers.tramo_ruta.path.length > 0"
                :options="{
                  ...markers.tramo_ruta.options,
                  strokeColor: tramoRuta.color,
                  strokeOpacity: '0.9',
                  strokeWeight: 5,
                }"
                :path="markers.tramo_ruta.path"
                :editable="accion_ruta"
                @dblclick="handleClickForDelete($event)"
                @path_changed="updateEdited($event)"
              >
              </gmap-polyline>
              <!-- Inicio de ruta -->
              <gmap-marker
                v-if="markers.inicio_tramo_ruta"
                :position="markers.inicio_tramo_ruta.position"
                :icon="url_docs + '/' + markers.inicio_tramo_ruta.icon"
              ></gmap-marker>
              <!-- Fin de ruta -->
              <gmap-marker
                v-if="markers.fin_tramo_ruta"
                :position="markers.fin_tramo_ruta.position"
                :icon="url_docs + '/' + markers.fin_tramo_ruta.icon"
              ></gmap-marker>
            </div>
            <!-- Iconos waypoints -->
            <div v-if="accion_ruta">
              <gmap-marker
                :key="index"
                v-for="(way, index) in markers.waypoints"
                :position="way.location"
                :icon="url_docs + '/image/iconos/waypoint.png'"
                :clickable="true"
                @click="(viewMap.center = way.location), toggleInfoWindow(way)"
                :draggable="true"
                @dragend="editWaypoint($event, index)"
              ></gmap-marker>
            </div>
          </gmap-map>
        </div>
      </div>
    </div>
    <!-- Paneles Visualización -->
    <div class="col-md-5" v-if="!accion_ruta">
      <div class="card m-0">
        <div class="card-header bg-light p-1">
          <!-- <label class="badge bg-geogo text-white text-md mr-2 mb-0 align-top">
            <div class="custom-control custom-checkbox">
              <input
                v-model="viewMap.nodos"
                @change="infoWinOpen = false"
                type="checkbox"
                id="viewMapNodos"
                class="custom-control-input"
                checked=""
              />
              <label for="viewMapNodos" class="custom-control-label">
                <i class="fas fa-map-pin text-xl p-1"></i>
              </label>
            </div>
            <div class="text-center">
              <span class="badge bg-success">Nodos</span>
            </div>
          </label> -->
          <!-- Indicaciones -->
          <label
            v-if="tramoRuta && tramoRuta.det_tramos_rutas.length > 0"
            class="badge bg-geogo text-white text-md mr-2 mb-0 text-center align-top"
            data-toggle="modal"
            data-target="#modal_indicaciones_tramos_ruta"
          >
            <div>
              <i class="fas fa-map-marked-alt text-xl p-1"></i>
            </div>
            <span class="badge bg-success">Indicaciones</span>
          </label>
        </div>
        <!-- Tabla Puntos Mapa -->
        <div
          v-if="tramoRuta && tramoRuta.det_tramos_rutas.length > 0"
          class="card-body table-responsive p-0"
        >
          <table
            class="table table-bordered text-nowrap table-responsive table-sm"
            style="height: 500px;"
          >
            <thead class="bg-dark text-white">
              <tr>
                <th class="text-center col-1" rowspan="2">Orden</th>
                <th class="text-center col-5" colspan="2">Posición Inicial</th>
                <th class="text-center col-5" colspan="2">Posición Final</th>
              </tr>
              <tr class="bg-info text-center">
                <th>Latitud</th>
                <th>Longitud</th>
                <th>Latitud</th>
                <th>Longitud</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rut in tramoRuta.det_tramos_rutas" :key="rut.id">
                <td class="text-center">
                  <span class="badge bg-info">{{ rut.orden }}</span>
                </td>
                <td>
                  <small>{{ rut.lat_ini }}</small>
                </td>
                <td>
                  <small>{{ rut.lon_ini }}</small>
                </td>
                <td>
                  <small>{{ rut.lat_fin }}</small>
                </td>
                <td>
                  <small>{{ rut.lon_fin }}</small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Modal Indicaciones Ruta -->
    <div class="modal fade" id="modal_indicaciones_tramos_ruta">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header pt-2 pb-2 bg-geogo">
            <h4 class="modal-title text-white">Indicaciones de Tramo Ruta</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <PanelIndicacionesTramosRuta
              ref="PanelIndicacionesTramosRuta"
            ></PanelIndicacionesTramosRuta>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
/* import vSelect from "vue-select"; */
import PanelIndicacionesTramosRuta from "../../../../components/PanelIndicacionesTramosRuta";

export default {
  name: "TramosRutasDetalle",

  components: {
    PanelIndicacionesTramosRuta,
    /* vSelect, */
  },

  data() {
    return {
      tramoRuta: null,
      tipo_sitio_img: "image/iconos/default.png",
      inicio_tramo_ruta: "image/iconos/inicio_ruta.png",
      fin_tramo_ruta: "image/iconos/fin_ruta.png",
      inicio_vel_max: "image/iconos/tacom-green.png",
      fin_vel_max: "image/iconos/tacom-red.png",
      latitud_ini: 4.651371,
      longitud_ini: -74.071509,
      form: {},
      form_vel: {},
      array_vel: [],
      coords: {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      },
      viewMap: {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        nodos: false,
      },
      markers: {
        nodos: [],
        inicio_tramo_ruta: null,
        fin_tramo_ruta: null,
        tramo_ruta: {
          path: [],
          options: {
            strokeColor: "#00529c",
            strokeOpacity: "0.9",
            strokeWeight: 5,
          },
        },
        waypoints: [],
        edit_max_vel: [],
      },
      accion_ruta: false,
      accion_coordenadas: false,
      // Datos para el cuadro de información del mapa
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      addressInput: "",
      codDane: {},
      ListasForm: {
        codigosDane: [],
      },
      detCodDane: [],
      chkCodDane: false,
      url_docs: process.env.VUE_APP_API_URL,
      mvcPath: null,
      distancia_tramo_ruta: 0,
    };
  },

  validations: {
    form_vel: {
      id: {
        required,
      },
      km_max: {
        required,
      },
    },
  },

  watch: {
    polylinePath: function(path) {
      if (path) {
        this.markers.tramo_ruta.path = path;
      }
    },
  },

  computed: {
    polylinePath: function() {
      if (!this.mvcPath) return null;

      let path = [];
      for (let j = 0; j < this.mvcPath.getLength(); j++) {
        let point = this.mvcPath.getAt(j);
        path.push({ lat: point.lat(), lng: point.lng() });
      }
      return path;
    },
  },

  methods: {
    // Helper method to check if Google Maps is loaded
    isGoogleMapsLoaded() {
      return (
        typeof window !== "undefined" &&
        window.google &&
        window.google.maps &&
        window.google.maps.geometry
      );
    },

    getIndex() {
      this.resetDatos();
      this.tramoRuta = this.$parent.tramoRuta ? this.$parent.tramoRuta : null;

      if (this.tramoRuta.waypoints) {
        this.markers.waypoints = JSON.parse(this.tramoRuta.waypoints).map(
          function(waypoint) {
            return {
              location: {
                lat: parseFloat(waypoint.location.lat),
                lng: parseFloat(waypoint.location.lng),
              },
              stopover: true,
            };
          }
        );
      } else {
        this.markers.waypoints = [];
      }

      this.tipo_sitio_img = "image/iconos/default.png";
      this.getMarkerNodos();
      this.getMarkersRuta();
      this.getPanelTramosRuta();
    },

    resetDatos() {
      this.tramoRuta = null;
      this.form = {};
      this.array_vel = [];
      let reset = document.getElementsByClassName("check-tramos");
      reset.forEach(function(checkbox) {
        checkbox.checked = false;
      });

      this.viewMap = {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        nodos: false,
      };

      this.markers = {
        nodos: [],
        inicio_tramo_ruta: null,
        fin_tramo_ruta: null,
        tramo_ruta: {
          path: [],
          options: {
            strokeColor: "#00529c",
            strokeOpacity: "0.9",
            strokeWeight: 5,
          },
        },
        waypoints: [],
        edit_max_vel: [],
      };
    },

    getDataFormVelMax(punto_ruta) {
      this.markers.edit_max_vel = [];
      this.array_vel = [];
      let reset = document.getElementsByClassName("check-tramos");
      reset.forEach(function(checkbox) {
        checkbox.checked = false;
      });
      this.form_vel = {
        id: [punto_ruta.id],
        km_max: punto_ruta.km_max,
      };
    },

    toggleInfoWindow: function(data) {
      this.infoWindowPos = data.position;
      this.infoContent = data.html;

      //compruebe si es el mismo marcador que se seleccionó en caso afirmativo alternar
      if (this.currentMidx == data.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si es un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = data.id;
      }
    },

    getMarkerNodos() {
      this.markers.nodos = [];
      if (this.tramoRuta.nodos) {
        this.tramoRuta.nodos.forEach((nodo) => {
          this.markers.nodos.push({
            id: nodo.id,
            position: {
              lat: parseFloat(nodo.latitud),
              lng: parseFloat(nodo.longitud),
            },
            icon: this.tipo_sitio_img,
            html: `
              <h3 class="text-sm mb-1">${nodo.codigo_dane}</h3>
              <p class="mb-0"><strong>${this.tramoRuta.nombre}</strong></p>
              `,
            /* <p class="mb-1"><small>${sit.ubicacion}</small></p> */
          });
        });
      }
    },

    getMarkersRuta() {
      this.markers.inicio_tramo_ruta = null;
      this.markers.fin_tramo_ruta = null;

      if (
        this.tramoRuta.det_tramos_rutas &&
        this.tramoRuta.det_tramos_rutas.length > 0
      ) {
        // Se establece la posicion de los iconos de inicio y fin de la ruta
        this.markers.inicio_tramo_ruta = {
          icon: this.inicio_tramo_ruta,
          position: {
            lat: parseFloat(
              this.tramoRuta.lat_origen
                ? this.tramoRuta.lat_origen
                : this.tramoRuta.det_tramos_rutas[0].lat_ini
            ),
            lng: parseFloat(
              this.tramoRuta.lng_origen
                ? this.tramoRuta.lng_origen
                : this.tramoRuta.det_tramos_rutas[0].lon_ini
            ),
          },
        };

        let lat = null;
        let lng = null;
        // Priorizar lat_destino y lng_destino si existen, sino usar det_tramos_rutas
        if (this.tramoRuta.lat_destino && this.tramoRuta.lng_destino) {
          lat = parseFloat(this.tramoRuta.lat_destino);
          lng = parseFloat(this.tramoRuta.lng_destino);
        } else if (
          this.tramoRuta.det_tramos_rutas &&
          this.tramoRuta.det_tramos_rutas.length > 0
        ) {
          const lastDetalle = this.tramoRuta.det_tramos_rutas[
            this.tramoRuta.det_tramos_rutas.length - 1
          ];
          if (lastDetalle.lat_fin && lastDetalle.lon_fin) {
            lat = parseFloat(lastDetalle.lat_fin);
            lng = parseFloat(lastDetalle.lon_fin);
          }
        }

        // Solo establecer el marker de destino si tenemos coordenadas válidas
        if (lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng)) {
          this.markers.fin_tramo_ruta = {
            icon: this.fin_tramo_ruta,
            position: {
              lat: lat,
              lng: lng,
            },
          };
        }

        // Se genera los puntos de la ruta a mostrar
        // Primero verificar si el tramo tiene un path guardado
        let pathData = null;
        if (this.tramoRuta.path) {
          // Si el path viene como string JSON, parsearlo
          if (typeof this.tramoRuta.path === "string") {
            try {
              pathData = JSON.parse(this.tramoRuta.path);
            } catch (e) {
              console.error("Error parsing path:", e);
            }
          } else if (Array.isArray(this.tramoRuta.path)) {
            pathData = this.tramoRuta.path;
          }
        }

        if (pathData && Array.isArray(pathData) && pathData.length > 0) {
          this.markers.tramo_ruta.path = pathData
            .map((point) => ({
              lat: parseFloat(point.lat),
              lng: parseFloat(point.lng),
            }))
            .filter((point) => !isNaN(point.lat) && !isNaN(point.lng));
        } else {
          // Si no hay path guardado, generarlo desde det_tramos_rutas
          this.markers.tramo_ruta.path = [];
          this.tramoRuta.det_tramos_rutas.forEach((det) => {
            if (det && det.lat_ini && det.lon_ini && det.orden == 1) {
              const latIni = parseFloat(det.lat_ini);
              const lngIni = parseFloat(det.lon_ini);
              if (!isNaN(latIni) && !isNaN(lngIni)) {
                this.markers.tramo_ruta.path.push({
                  lat: latIni,
                  lng: lngIni,
                });
              }
            }
            if (det && det.lat_fin && det.lon_fin) {
              const latFin = parseFloat(det.lat_fin);
              const lngFin = parseFloat(det.lon_fin);
              if (!isNaN(latFin) && !isNaN(lngFin)) {
                this.markers.tramo_ruta.path.push({
                  lat: latFin,
                  lng: lngFin,
                });
              }
            }
          });
        }
      } else if (
        this.tramoRuta.lat_origen &&
        this.tramoRuta.lng_origen &&
        this.tramoRuta.lat_destino &&
        this.tramoRuta.lng_destino
      ) {
        // Si no hay det_tramos_rutas pero hay coordenadas de origen y destino, usarlas
        const latOrigen = parseFloat(this.tramoRuta.lat_origen);
        const lngOrigen = parseFloat(this.tramoRuta.lng_origen);
        const latDestino = parseFloat(this.tramoRuta.lat_destino);
        const lngDestino = parseFloat(this.tramoRuta.lng_destino);

        if (!isNaN(latOrigen) && !isNaN(lngOrigen)) {
          this.markers.inicio_tramo_ruta = {
            icon: this.inicio_tramo_ruta,
            position: {
              lat: latOrigen,
              lng: lngOrigen,
            },
          };
        }

        if (!isNaN(latDestino) && !isNaN(lngDestino)) {
          this.markers.fin_tramo_ruta = {
            icon: this.fin_tramo_ruta,
            position: {
              lat: latDestino,
              lng: lngDestino,
            },
          };
        }

        // Generar el path del tramo
        // Primero verificar si el tramo tiene un path guardado
        let pathData = null;
        if (this.tramoRuta.path) {
          // Si el path viene como string JSON, parsearlo
          if (typeof this.tramoRuta.path === "string") {
            try {
              pathData = JSON.parse(this.tramoRuta.path);
            } catch (e) {
              console.error("Error parsing path:", e);
            }
          } else if (Array.isArray(this.tramoRuta.path)) {
            pathData = this.tramoRuta.path;
          }
        }

        if (pathData && Array.isArray(pathData) && pathData.length > 0) {
          this.markers.tramo_ruta.path = pathData
            .map((point) => ({
              lat: parseFloat(point.lat),
              lng: parseFloat(point.lng),
            }))
            .filter((point) => !isNaN(point.lat) && !isNaN(point.lng));
        } else {
          // Si no hay path guardado, crear una línea recta entre origen y destino
          this.markers.tramo_ruta.path = [
            { lat: latOrigen, lng: lngOrigen },
            { lat: latDestino, lng: lngDestino },
          ];
        }
      }
      this.sincronizarDistanciaTramoDesdeServidorOPath();
      this.centrarMapa();
    },

    getPanelTramosRuta() {
      let tramoRuta = [];
      // creo el arreglo de coordenadas
      this.tramoRuta.det_tramos_rutas.forEach((det) => {
        if (det.orden == 1) {
          tramoRuta.push({
            lat: parseFloat(det.lat_ini),
            lng: parseFloat(det.lon_ini),
          });
        }
        tramoRuta.push({
          lat: parseFloat(det.lat_fin),
          lng: parseFloat(det.lon_fin),
        });
      });
      this.$refs.PanelIndicacionesTramosRuta.getIndex(
        tramoRuta,
        this.tramoRuta.waypoints,
        this.tramoRuta.color
      );
    },

    // Funciones para el manejo general del mapa
    sincronizarDistanciaTramoDesdeServidorOPath() {
      if (!this.tramoRuta) {
        return;
      }
      const kmDb = parseFloat(this.tramoRuta.distancia_km);
      if (!isNaN(kmDb) && kmDb > 0) {
        this.distancia_tramo_ruta = kmDb.toFixed(3);
        return;
      }
      const path =
        this.markers.tramo_ruta && this.markers.tramo_ruta.path
          ? this.markers.tramo_ruta.path
          : [];
      if (path.length >= 2) {
        const m = this.distanciaMetrosDesdePath(path);
        this.distancia_tramo_ruta = (m / 1000).toFixed(3);
      }
    },

    distanciaMetrosDesdePath(path) {
      if (!path || path.length < 2) {
        return 0;
      }
      if (this.isGoogleMapsLoaded()) {
        const ll = path.map(
          (p) => new window.google.maps.LatLng(p.lat, p.lng)
        );
        return window.google.maps.geometry.spherical.computeLength(ll);
      }
      let total = 0;
      for (let i = 1; i < path.length; i++) {
        total += this.calcularDistancia(path[i - 1], path[i]);
      }
      return total;
    },

    distanciaMetrosParaZoom(inicio, fin) {
      const path =
        this.markers.tramo_ruta && this.markers.tramo_ruta.path
          ? this.markers.tramo_ruta.path
          : [];
      if (path.length >= 2) {
        return this.distanciaMetrosDesdePath(path);
      }
      return this.calcularDistancia(inicio, fin);
    },

    centrarMapa() {
      if (this.markers.inicio_tramo_ruta && this.markers.fin_tramo_ruta) {
        const inicio = this.markers.inicio_tramo_ruta.position;
        const fin = this.markers.fin_tramo_ruta.position;
        this.viewMap.center = {
          lat: (inicio.lat + fin.lat) / 2,
          lng: (inicio.lng + fin.lng) / 2,
        };
        const dZoomMetros = this.distanciaMetrosParaZoom(inicio, fin);
        this.viewMap.zoom = this.calcularZoomMapa(dZoomMetros);
      } else if (this.markers.inicio_tramo_ruta) {
        const inicio = this.markers.inicio_tramo_ruta.position;
        this.viewMap.center = {
          lat: inicio.lat,
          lng: inicio.lng,
        };
      } else if (this.markers.fin_tramo_ruta) {
        const fin = this.markers.fin_tramo_ruta.position;
        this.viewMap.center = {
          lat: fin.lat,
          lng: fin.lng,
        };
      } else {
        this.viewMap.center = {
          lat: this.latitud_ini,
          lng: this.longitud_ini,
        };
      }
    },

    calcularDistancia(origin, destination) {
      if (!this.isGoogleMapsLoaded()) {
        console.warn("Google Maps no está cargado aún");
        // Retornar una distancia aproximada usando la fórmula de Haversine como fallback
        const R = 6371000; // Radio de la Tierra en metros
        const dLat = ((destination.lat - origin.lat) * Math.PI) / 180;
        const dLng = ((destination.lng - origin.lng) * Math.PI) / 180;
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((origin.lat * Math.PI) / 180) *
            Math.cos((destination.lat * Math.PI) / 180) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      }
      return window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(origin.lat, origin.lng),
        new window.google.maps.LatLng(destination.lat, destination.lng)
      );
    },

    calcularZoomMapa(distancia) {
      return Math.max(
        1,
        Math.min(Math.round(16 - Math.log2(distancia / 1000)), 18)
      );
    },

    async calcularRuta() {
      // Validar que los markers existan antes de calcular la ruta
      if (
        !this.markers.inicio_tramo_ruta ||
        !this.markers.inicio_tramo_ruta.position
      ) {
        console.error("Marker de inicio no está inicializado");
        return;
      }

      if (
        !this.markers.fin_tramo_ruta ||
        !this.markers.fin_tramo_ruta.position
      ) {
        console.error("Marker de destino no está inicializado");
        return;
      }

      // Verificar que Google Maps esté cargado
      if (!this.isGoogleMapsLoaded()) {
        console.warn("Google Maps no está cargado aún, esperando...");
        // Esperar un poco y reintentar
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (!this.isGoogleMapsLoaded()) {
          console.error("Google Maps no está disponible");
          // Crear un path simple entre origen y destino como fallback
          if (this.markers.inicio_tramo_ruta && this.markers.fin_tramo_ruta) {
            this.markers.tramo_ruta.path = [
              this.markers.inicio_tramo_ruta.position,
              this.markers.fin_tramo_ruta.position,
            ];
          }
          return;
        }
      }

      this.$parent.cargando = true;
      try {
        const directionsService = new window.google.maps.DirectionsService();
        const request = {
          origin: this.markers.inicio_tramo_ruta.position,
          destination: this.markers.fin_tramo_ruta.position,
          waypoints: this.markers.waypoints || [],
          travelMode: window.google.maps.TravelMode.DRIVING,
        };

        const result = await new Promise((resolve, reject) => {
          directionsService.route(request, (res, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              resolve(res);
            } else {
              reject(new Error(status));
            }
          });
        });

        let distanciaMetros = 0;
        const allCoordinates = [];
        result.routes.forEach((route) => {
          route.legs.forEach((leg) => {
            distanciaMetros += leg.distance.value;
            leg.steps.forEach((stp) => {
              const stepCoordinates = stp.path.map((element) => ({
                lat: element.lat(),
                lng: element.lng(),
              }));
              allCoordinates.push(...stepCoordinates);
            });
          });
        });

        this.distancia_tramo_ruta =
          distanciaMetros > 0
            ? (distanciaMetros / 1000).toFixed(3)
            : "0.000";

        if (allCoordinates.length > 0) {
          const tolerance = 0.00025;
          this.markers.tramo_ruta.path = this.simplifyPolyline(
            allCoordinates,
            tolerance
          );
        } else if (
          this.markers.inicio_tramo_ruta &&
          this.markers.fin_tramo_ruta
        ) {
          this.markers.tramo_ruta.path = [
            this.markers.inicio_tramo_ruta.position,
            this.markers.fin_tramo_ruta.position,
          ];
        }
      } catch (e) {
        this.getMarkersRuta();
        this.$swal({
          icon: "error",
          title: "No se pudo cargar la ruta: " + (e.message || e),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        if (this.markers.inicio_tramo_ruta && this.markers.fin_tramo_ruta) {
          this.markers.tramo_ruta.path = [
            this.markers.inicio_tramo_ruta.position,
            this.markers.fin_tramo_ruta.position,
          ];
        }
      } finally {
        this.$parent.cargando = false;
      }
    },
    // Fin - Funciones para el manejo general del mapa

    // Funciones que vienen del autocomplete de google
    setPlaceOrigen(place) {
      if (!place || !place.geometry || !place.geometry.location) {
        console.error("Place inválido en setPlaceOrigen");
        return;
      }

      const lat = parseFloat(place.geometry.location.lat());
      const lng = parseFloat(place.geometry.location.lng());

      if (isNaN(lat) || isNaN(lng)) {
        console.error("Coordenadas inválidas en setPlaceOrigen");
        return;
      }

      this.markers.inicio_tramo_ruta = {
        icon: this.inicio_tramo_ruta,
        position: {
          lat: lat,
          lng: lng,
        },
      };

      // Asegurar que el path existe antes de acceder a él
      if (!this.markers.tramo_ruta.path) {
        this.markers.tramo_ruta.path = [];
      }

      if (this.markers.tramo_ruta.path.length === 0) {
        this.markers.tramo_ruta.path.push({
          lat: lat,
          lng: lng,
        });
      } else {
        this.markers.tramo_ruta.path[0] = {
          lat: lat,
          lng: lng,
        };
      }

      if (this.markers.fin_tramo_ruta) {
        this.calcularRuta();
      }
      this.centrarMapa();
    },

    setPlaceDestino(place) {
      if (!place || !place.geometry || !place.geometry.location) {
        console.error("Place inválido en setPlaceDestino");
        return;
      }

      const lat = parseFloat(place.geometry.location.lat());
      const lng = parseFloat(place.geometry.location.lng());

      if (isNaN(lat) || isNaN(lng)) {
        console.error("Coordenadas inválidas en setPlaceDestino");
        return;
      }

      this.markers.fin_tramo_ruta = {
        icon: this.fin_tramo_ruta,
        position: {
          lat: lat,
          lng: lng,
        },
      };

      // Asegurar que el path existe antes de acceder a él
      if (!this.markers.tramo_ruta.path) {
        this.markers.tramo_ruta.path = [];
      }

      if (this.markers.tramo_ruta.path.length > 1) {
        this.markers.tramo_ruta.path[
          this.markers.tramo_ruta.path.length - 1
        ] = {
          lat: lat,
          lng: lng,
        };
      } else {
        this.markers.tramo_ruta.path.push({
          lat: lat,
          lng: lng,
        });
      }
      this.calcularRuta();
      this.centrarMapa();
    },

    setPlaceWaypoint(place) {
      this.markers.waypoints.push({
        location: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        },
        stopover: true,
      });
      this.calcularRuta();
      this.centrarMapa();
    },

    actDatos() {
      this.calcularRuta();
      this.centrarMapa();
    },

    setCodDaneWaypoint() {
      if (this.codDane) {
        this.markers.waypoints.push({
          location: {
            lat: parseFloat(this.codDane.latitud),
            lng: parseFloat(this.codDane.longitud),
          },
          stopover: true,
        });

        this.detCodDane.push(this.codDane);
      }
    },
    // Fin - Funciones que vienen del autocomplete de google

    handleClickForDelete($event) {
      if ($event.vertex !== undefined) {
        this.markers.tramo_ruta.path.splice($event.vertex, 1);
      }
    },

    updateEdited: function(mvcPath) {
      this.mvcPath = mvcPath;
    },

    // Funciones que vienen de los campos de coordenadas
    resetCoors() {
      this.coords = {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      };
    },

    setCoordOrigen() {
      if (this.coords.lat_origen && this.coords.lng_origen) {
        const lat = parseFloat(this.coords.lat_origen);
        const lng = parseFloat(this.coords.lng_origen);

        // Validar que los valores sean números válidos
        if (isNaN(lat) || isNaN(lng)) {
          console.error(
            "Coordenadas inválidas:",
            this.coords.lat_origen,
            this.coords.lng_origen
          );
          return;
        }

        this.markers.inicio_tramo_ruta = {
          icon: this.inicio_tramo_ruta,
          position: {
            lat: lat,
            lng: lng,
          },
        };

        // Asegurar que el path existe antes de acceder a él
        if (!this.markers.tramo_ruta.path) {
          this.markers.tramo_ruta.path = [];
        }

        if (this.markers.tramo_ruta.path.length === 0) {
          this.markers.tramo_ruta.path.push({
            lat: lat,
            lng: lng,
          });
        } else {
          this.markers.tramo_ruta.path[0] = {
            lat: lat,
            lng: lng,
          };
        }

        if (this.markers.fin_tramo_ruta) {
          this.calcularRuta();
        }
        this.centrarMapa();
      }
    },

    setCoordDestino() {
      if (this.coords.lat_destino && this.coords.lng_destino) {
        const lat = parseFloat(this.coords.lat_destino);
        const lng = parseFloat(this.coords.lng_destino);

        // Validar que los valores sean números válidos
        if (isNaN(lat) || isNaN(lng)) {
          console.error(
            "Coordenadas inválidas:",
            this.coords.lat_destino,
            this.coords.lng_destino
          );
          return;
        }

        this.markers.fin_tramo_ruta = {
          icon: this.fin_tramo_ruta,
          position: {
            lat: lat,
            lng: lng,
          },
        };

        // Asegurar que el path existe antes de acceder a él
        if (!this.markers.tramo_ruta.path) {
          this.markers.tramo_ruta.path = [];
        }

        if (this.markers.tramo_ruta.path.length > 1) {
          this.markers.tramo_ruta.path[
            this.markers.tramo_ruta.path.length - 1
          ] = {
            lat: lat,
            lng: lng,
          };
        } else {
          this.markers.tramo_ruta.path.push({
            lat: lat,
            lng: lng,
          });
        }
        this.calcularRuta();
        this.centrarMapa();
      }
    },
    // Fin - Funciones que vienen de los campos de coordenadas

    // Funciones para los waypoints
    editWaypoint(event, index) {
      this.markers.waypoints[index] = {
        location: {
          lat: parseFloat(event.latLng.lat()),
          lng: parseFloat(event.latLng.lng()),
        },
        stopover: true,
      };
      this.calcularRuta();
    },

    removeWaypoint(index) {
      this.markers.waypoints.splice(index, 1);
      this.calcularRuta();
    },

    removeCodDaneWaypoint(index) {
      this.markers.waypoints.splice(index, 1);
      this.detCodDane.splice(index, 1);
      this.calcularRuta();
    },

    save() {
      this.$swal({
        title: "Está seguro de editar esta ruta?",
        text:
          "Los cambios se guardarán y podrán ser editados nuevamente en el panel de edición de tramos de ruta!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Modificar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;

          // Asegurar que los markers existan antes de usarlos
          if (!this.markers.inicio_tramo_ruta || !this.markers.fin_tramo_ruta) {
            this.$parent.cargando = false;
            this.$swal({
              icon: "error",
              title: "Error: Faltan coordenadas de origen o destino",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            return;
          }

          this.form = {
            id: this.tramoRuta.id,
            path: this.markers.tramo_ruta.path,
            waypoints: JSON.stringify(this.markers.waypoints),
            waypointsCodDane: this.detCodDane,
            lng_origen: parseFloat(this.markers.inicio_tramo_ruta.position.lng),
            lat_origen: parseFloat(this.markers.inicio_tramo_ruta.position.lat),
            lng_destino: parseFloat(this.markers.fin_tramo_ruta.position.lng),
            lat_destino: parseFloat(this.markers.fin_tramo_ruta.position.lat),
          };

          axios
            .post("/api/admin/tramosRutas/saveDetalle", this.form)
            .then((response) => {
              this.$parent.cargando = false;
              this.accion_ruta = false;
              this.$parent.getIndex();

              this.$swal({
                icon: "success",
                title: "Se guardó exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            })
            .catch((error) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "error",
                title: "Ocurrió un error: " + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    buscarCodigosDane(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/ciudades/lista?dato=" + search;
        axios
          .get(url)
          .then(function(response) {
            let ciudades = response.data;
            let lista = [];
            for (let i = 0; i < ciudades.length; i++) {
              const ciudad = ciudades[i];
              if (ciudad.latitud && ciudad.longitud) {
                lista.push({
                  id: ciudad.id,
                  codigo: ciudad.cod_dane + " - " + ciudad.nombre,
                  longitud: ciudad.longitud,
                  latitud: ciudad.latitud,
                });
              }
            }
            me.ListasForm.codigosDane = lista;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    // Función para calcular la distancia perpendicular entre un punto y una línea definida por dos puntos
    perpendicularDistance(point, lineStart, lineEnd) {
      let x = point.lat;
      let y = point.lng;
      let x1 = lineStart.lat;
      let y1 = lineStart.lng;
      let x2 = lineEnd.lat;
      let y2 = lineEnd.lng;

      let numerator = Math.abs(
        (y2 - y1) * x - (x2 - x1) * y + x2 * y1 - y2 * x1
      );
      let denominator = Math.sqrt(Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2));

      return denominator === 0 ? 0 : numerator / denominator;
    },

    // Algoritmo Douglas-Peucker
    douglasPeucker(points, tolerance) {
      if (points.length < 3) {
        return points;
      }

      let maxDistance = 0;
      let index = 0;
      let startPoint = points[0];
      let endPoint = points[points.length - 1];

      // Encontrar el punto con la mayor distancia perpendicular al segmento
      for (let i = 1; i < points.length - 1; i++) {
        let distance = this.perpendicularDistance(
          points[i],
          startPoint,
          endPoint
        );
        if (distance > maxDistance) {
          index = i;
          maxDistance = distance;
        }
      }

      // Si la distancia máxima es mayor que el umbral de tolerancia, dividir la polilínea
      if (maxDistance > tolerance) {
        let left = this.douglasPeucker(points.slice(0, index + 1), tolerance);
        let right = this.douglasPeucker(points.slice(index), tolerance);

        return left.slice(0, left.length - 1).concat(right);
      } else {
        // Si no hay puntos significativos, devolver los extremos
        return [startPoint, endPoint];
      }
    },

    // Función para simplificar la polilínea
    simplifyPolyline(points, tolerance) {
      if (!points || points.length === 0) return [];
      return this.douglasPeucker(points, tolerance);
    },
  },
};
</script>
<style>
.bg-coordenadas {
  background: linear-gradient(to right, #c7123c, #303338) !important;
}
</style>
